import { Route } from '@angular/router';
import { TValidUserRoles } from '../shared/typings/interfaces/user.interface';
import { notFoundRoute } from './not-found/not-found.route';
import { shelterRoute } from './shelter/shelter.route';
import { shelterPickerRoute } from './shelter-picker/shelter-picker.route';
import { shelterNetworkSettingsRoute } from './shelter-network-settings/shelter-network-settings.route';

export interface IRouteConfigsOpts extends Route {
  url?: string;
  rolePermissions: TValidUserRoles[];
  authenticationRequired: boolean;
}

export interface IRouteConfigs {
  [routeName: string]: IRouteConfigsOpts;
}

export const ROUTE_CONFIGS = new Map();

/**
 * Add routes here { file : fileCameled }
 * routes/shelter/shelter.route.ts --> ROUTE_CONFIGS.set('shelter.route', shelterRoute);
 */
ROUTE_CONFIGS.set('shelter-picker.route', shelterPickerRoute);
ROUTE_CONFIGS.set('shelter-network-settings.route', shelterNetworkSettingsRoute);
ROUTE_CONFIGS.set('shelter.route', shelterRoute);
ROUTE_CONFIGS.set('not-found.route', notFoundRoute);
